module.exports = __webpack_public_path__ + "img/Plant.52d96e96.png";